<template>
  <a-popconfirm
    v-model="visible"
    placement="top"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    @confirm="confirm"
  >
    <a-icon
      slot="icon"
      type="ww"
    />
    <template slot="title">
      <a-form
        :form="form"
      >
        <a-form-item
          :required="true"
        >
          <a-input
            v-decorator="['title', {rules: [{ required: true, message: classNamePlace }, {validator: validRepeat}], initialValue: ''}]"
            maxlength="30"
            :placeholder="classNamePlace"
          />
        </a-form-item>
      </a-form>
    </template>
    <a-button class="add-btn">
      <!-- 增加一项 -->
      <i class="iconfont iconicon-test10" />&nbsp;{{ $t('message[1561]') }}
    </a-button>
  </a-popconfirm>
</template>
<script>

export default {
  props: {
    datas: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      isShow: false,
      visible: false
    }
  },
  computed: {
    classNamePlace () {
      return this.$t('message["770"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    confirm (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll(['title'], (err, values) => {
        if (err) {
          this.visible = true
        } else {
          this.$emit('addTree', this.form.getFieldValue('title'))
          this.form.setFieldsValue({ title: '' })
        }
      })
    },
    validRepeat (rule, value, callback) {
      const len = this.datas.filter(item => item.name === value).length
      if (value && len > 0) {
        callback(new Error(this.$t('message["297"]')))
      } else {
        callback()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-btn {
  margin: 10px 0 16px 36px;
  .iconfont {
    color: #d6d6d6;
  }
}
</style>
